import { sitApi } from './sitApiClient';

export async function getReport(runId) {
  const { data } = await sitApi.get(`/reports/${encodeURIComponent(runId)}`);
  return data;
}

/**
 * Fetch the binary PDF artifact for a run. Returns a Blob the caller can
 * pipe to a download anchor.
 */
export async function getReportPdf(runId) {
  const res = await sitApi.get(`/reports/${encodeURIComponent(runId)}?format=pdf`, {
    responseType: 'blob'
  });
  return res.data;
}

export async function getReportMarkdown(runId) {
  const res = await sitApi.get(`/reports/${encodeURIComponent(runId)}?format=md`, {
    responseType: 'text'
  });
  return res.data;
}
